export const MODULE_LAYOUT_SCROLL_RESTORATION_KEY = 'module-layout-scroll-restoration'
